module.exports = function(bh) {
    bh.match('form-check', function(ctx, json) {
        ctx
            .tParam('ID', ctx.generateId(), true)
            .content([
                {elem: 'input', attrs: {
                    type: json.type || 'checkbox',
                    name: json.name,
                    disabled: json.disabled,
                    checked: json.checked,
                    value: json.value,
                    required: json.required,
                }},
                {elem: 'label', content: ctx.content()},
              {cls: 'invalid-feedback', content: 'Выберите пункт сверху'},
            ], ctx.isSimple(ctx.content()));
    });
};
